module.exports = __webpack_public_path__ + "static/img/h2.f214a8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h2.jpg
// module id = RyNe
// module chunks = 0